var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"main",staticClass:"color-drop",class:{ 'dragging': _vm.dragging },style:({
     left: _vm.hsv[1] + '%',
     top: (100 - _vm.hsv[2]) + '%',
     background: _vm.selected.hex()
     })})
}
var staticRenderFns = []

export { render, staticRenderFns }